/**
 * sk-plant-freight.js — Speditionsfracht der Pflanzen offen vor der Kasse (snippets/sk-plant-freight.liquid), 16.10.2026.
 * Philipp: kein Mindestbestellwert – die Fracht transparent zeigen; berechnet wird sie wie bisher an der Kasse
 * (CarrierService „Speditionslieferung auf Palette").
 *
 * Eine Komponente, mehrere Einstiege:
 *   'pdp'    Kasten unter der Summe der Mengen-View (Auswahl + Speditions-Pflanzen im Warenkorb)
 *   'modal'  Pop-up hinter „zzgl. Versandkosten" am Preis und an der Summe ([data-sk-pf-open] → <dialog data-sk-pf-modal>)
 *   'drawer' / 'cart'  Warenkorb-Drawer und Seite /cart (nur Speditions-Pflanzen im Warenkorb)
 *
 * Maßgeblich ist die Versandklasse der Variante (Metafeld pflanze.versandklasse), NICHT SKU oder Produkttyp:
 *   – Mengen-View: data-cart-ship je Zeile (snippets/sk-plant-qty-matrix.liquid)
 *   – Warenkorb: /cart?view=sk-freight (templates/cart.sk-freight.liquid, JSON inkl. Klasse; /cart.js hat keine Metafelder)
 * Nur Klassen in FREIGHT_CLASSES bekommen eine Frachtanzeige; alle anderen (künftig z. B. „paket") laufen über den
 * normalen Shop-Versand (Versandkosten-Leiste, Checkout) und bleiben hier unberücksichtigt.
 * Neue Klasse mit eigener Anzeige (z. B. Paket-Partner mit eigener Tarif-API): Eintrag in FREIGHT_CLASSES mit quote(),
 * Texte im Metaobjekt „pflanzen-lieferung" (pflanzen-pdp/multi/texte.py) ergänzen, Kasten je Klasse rendern
 * (sk-plant-freight.liquid bekommt dann einen Parameter „klasse") und die Liquid-Bedingungen == 'spedition'
 * (sk-plant-qty-matrix, product-price, sk-drawer, static-cart, free-shipping-bar) erweitern.
 *
 * Frachtmodelle (18.10.2026, Fertighecken-Elemente): Das ERP rechnet je Lieferant (SKU 81… = PLZ-Zone × Gewicht mit
 * Mindestgewicht, 82… = Pauschale je angefangener Palette) und liefert die Aufschlüsselung in res.models.weight/.flat.
 * Nur Pauschale → Kasten ohne PLZ und ohne kg-Texte (showFlat); gemischt → Gewichtsteil wie bisher + Zeile mit der
 * Palettenpauschale (zweite Lieferung). Der Kasten der Produktseite kennt das Modell des Produkts (data-model, Leerabfrage).
 *
 * PLZ: localStorage „sk_plant_plz", gilt für alle Kästen. Warenkorb-Stand: /cart?view=sk-freight beim Start, danach
 * window.skPlantFreight.setCart(cart) (assets/sk-drawer.js) und die Ereignisse „cartcount:update" (voller Warenkorb aus
 * assets/sk-plant-qm.js) und „sk:cart-changed". Auswahl der Mengen-View: Ereignis „sk-plant:qm-lines" (assets/sk-plant-qm.js).
 * /cart rendert Empire nach Mengenänderungen neu → neue Kästen übernimmt ein MutationObserver.
 */
(function () {
  'use strict';
  if (window.skPlantFreight) return;

  var ROOT_URL = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  var PLZ_KEY = 'sk_plant_plz';

  /* Versandklassen mit eigener Frachtanzeige (Schlüssel = Wert von pflanze.versandklasse) */
  var FREIGHT_CLASSES = {
    spedition: {
      // ERP: dieselbe Rechnung wie der CarrierService im Checkout. Ohne Positionen: kleinste Lieferung (Pauschale bis
      // Mindestgewicht) – für „ab … bis …" bzw. „Fracht nach PLZ" ohne Auswahl.
      api: 'https://erp-api-289183413262.europe-west1.run.app/public/plant-freight/quote',
      emptyItems: [{ sku: '8100000-0', quantity: 1, grams: 1 }],
      // Produktseite eines Pauschal-Produkts (data-model="flat") ohne Auswahl: eine Palette
      emptyItemsFlat: [{ sku: '8200000-0', quantity: 1, grams: 1 }]
    }
  };
  function isFlatSku(sku) { return /^82\d{5}-\d+$/.test(String(sku || '').trim()); }
  var CLS = 'spedition'; // die Kästen in sk-plant-freight.liquid zeigen (bisher) nur diese Klasse

  var cache = {};
  var classOf = {};      // variant_id → Versandklasse ('' = keine)
  var daysOf = {};       // variant_id → [Werktage min, max] (pflanze.lieferzeit_tage_*, aus /cart?view=sk-freight)
  var cart = null;       // { items: [{variant_id, sku, quantity, grams, line_cents, cls}], total }
  var boxes = [];
  var modal = null;
  var lastTrigger = null;

  function $(sel, root) { return (root || document).querySelector(sel); }
  function $$(sel, root) { return Array.prototype.slice.call((root || document).querySelectorAll(sel)); }
  function readJSON(el) {
    if (!el) return {};
    try { return JSON.parse(el.textContent) || {}; } catch (e) { return {}; }
  }
  var decoder = document.createElement('textarea');
  function decodeAll(obj) {
    Object.keys(obj).forEach(function (k) {
      if (typeof obj[k] === 'string' && obj[k].indexOf('&') > -1) { decoder.innerHTML = obj[k]; obj[k] = decoder.value; }
    });
    return obj;
  }
  function fill(str, map) {
    return String(str || '').replace(/%([A-Z]+)%/g, function (m, k) { return map[k] != null ? map[k] : m; });
  }
  function getPlz() {
    try { var v = window.localStorage.getItem(PLZ_KEY) || ''; return /^\d{5}$/.test(v) ? v : ''; } catch (e) { return ''; }
  }
  function setPlz(v) {
    try { if (v) window.localStorage.setItem(PLZ_KEY, v); else window.localStorage.removeItem(PLZ_KEY); } catch (e) { /* privat */ }
  }

  /* ---------- Versandklassen je Variante (nur aktuelle Quellen: Zeilen dieser Seite + /cart?view=sk-freight) ---------- */
  function learnClasses() {
    $$('[data-sk-qm-row][data-variant-id]').forEach(function (row) {
      classOf[row.getAttribute('data-variant-id')] = row.getAttribute('data-cart-ship') || '';
    });
  }

  function quote(cls, plz, items) {
    var conf = FREIGHT_CLASSES[cls];
    var body = { country: 'DE', items: items };
    if (plz) body.postalCode = plz;
    var key = cls + '|' + JSON.stringify(body);
    if (!cache[key]) {
      cache[key] = fetch(conf.api, {
        method: 'POST',
        credentials: 'omit',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify(body)
      }).then(function (r) {
        if (!r.ok) throw new Error('plant-freight ' + r.status);
        return r.json();
      });
      cache[key].catch(function () { delete cache[key]; });
    }
    return cache[key];
  }

  /* ---------- Warenkorb ---------- */
  // Nimmt /cart.js- oder /cart?view=sk-freight-Daten. Fehlt für eine Variante die Klasse, wird die View nachgeladen;
  // bis dahin zählt sie als normale Versandware (Kästen rechnen sofort mit dem neuen Warenkorb).
  var cartSeq = 0;
  function setCart(c, fromView) {
    if (!c || !c.items) return;
    cartSeq++;
    var unknown = false;
    var items = c.items.map(function (it) {
      var id = String(it.variant_id);
      if (typeof it.cls === 'string') classOf[id] = it.cls;
      if (typeof it.dmax === 'number') daysOf[id] = [it.dmin || 0, it.dmax || 0];
      // Lieferzeit fehlt (z. B. Klasse aus der Mengen-View gelernt) → View nachladen (Drawer-Trust-Zeile, sk-drawer.js)
      if (classOf[id] == null || (FREIGHT_CLASSES[classOf[id]] && !daysOf[id])) unknown = true;
      return {
        variant_id: id,
        sku: it.sku || '',
        quantity: it.quantity || 0,
        grams: it.grams || 0,
        line_cents: it.line_cents != null ? it.line_cents : (it.final_line_price != null ? it.final_line_price : it.line_price || 0)
      };
    });
    cart = { items: items, total: c.items_subtotal_price != null ? c.items_subtotal_price : c.total_price };
    refreshAll();
    if (unknown && !fromView) loadCart();
  }
  function refreshAll() {
    boxes.forEach(function (b) { b.schedule(0); });
    var sp = split();
    // /cart-Seitenleiste (sections/static-cart.liquid): Paket-Versandkostenregel nur ohne reine Speditionsware,
    // Pflanzen-Hinweis nur mit Speditionsware – nach Empire-Neurendern bzw. Entfernen von Positionen
    if (sp.known) {
      $$('[data-sk-cart-ship-std]').forEach(function (el) { el.hidden = sp.onlyFreight; });
      $$('[data-sk-cart-ship-plant]').forEach(function (el) { el.hidden = !sp.hasFreight; });
    }
    window.dispatchEvent(new CustomEvent('sk-plant-freight:cart', { detail: sp }));
  }
  var cartLoading = null;
  var cartAgain = false;
  function loadCart() {
    if (cartLoading) { cartAgain = true; return cartLoading; }
    var seq = cartSeq;
    // ⛔ Ohne „Accept: application/json": damit liefert Shopify für /cart das cart.js-JSON statt der View (ohne Klassen)
    cartLoading = fetch(ROOT_URL + 'cart?view=sk-freight', { credentials: 'same-origin' })
      .then(function (r) { return r.ok ? r.text() : ''; })
      .then(function (txt) {
        var c = null;
        try { c = JSON.parse(txt); } catch (e) { c = null; }
        if (c && c.items) {
          c.items.forEach(function (it) {
            if ('cls' in it) classOf[String(it.variant_id)] = it.cls || '';
            if ('dmax' in it) daysOf[String(it.variant_id)] = [it.dmin || 0, it.dmax || 0];
          });
          // Inzwischen neuerer Warenkorb (Drawer/Mengen-View)? Dann nur die Klassen übernehmen, nicht den alten Stand
          if (seq === cartSeq) setCart(c, true); else refreshAll();
        }
      })
      .catch(function () { /* Netz/Botschutz: Kästen bleiben beim letzten Stand */ })
      .then(function () {
        cartLoading = null;
        if (cartAgain) { cartAgain = false; loadCart(); }
      });
    return cartLoading;
  }
  function cartItems(cls) {
    return (cart ? cart.items : []).filter(function (it) { return classOf[it.variant_id] === cls; })
      .map(function (it) { return { sku: it.sku, quantity: it.quantity, grams: it.grams }; });
  }
  // Für die Versandkosten-Leiste des Drawers (assets/sk-drawer.js): Fracht-Positionen herausrechnen
  function split(c) {
    var src = c && c.items ? c.items : (cart ? cart.items : []);
    // dmin/dmax: Lieferzeit der Fracht-Positionen (kleinstes Minimum bis größtes Maximum), daysKnown = für alle vorhanden
    var res = { freightCents: 0, otherCents: 0, hasFreight: false, onlyFreight: false, known: true, dmin: 0, dmax: 0, daysKnown: true };
    src.forEach(function (it) {
      var id = String(it.variant_id);
      var cents = it.line_cents != null ? it.line_cents : (it.final_line_price != null ? it.final_line_price : it.line_price || 0);
      if (classOf[id] == null) res.known = false;
      if (FREIGHT_CLASSES[classOf[id]]) {
        res.freightCents += cents;
        res.hasFreight = true;
        var d = daysOf[id];
        if (!d) { res.daysKnown = false; return; }
        var lo = d[0] || d[1], hi = d[1] || d[0];
        if (lo > 0 && (!res.dmin || lo < res.dmin)) res.dmin = lo;
        if (hi > res.dmax) res.dmax = hi;
      } else res.otherCents += cents;
    });
    res.onlyFreight = res.hasFreight && res.otherCents === 0;
    return res;
  }

  /* ---------- Kasten ---------- */
  function Box(el) {
    this.el = el;
    this.ctx = el.getAttribute('data-sk-plant-freight') || 'pdp';
    this.compact = this.ctx === 'drawer' || this.ctx === 'cart';
    this.i18n = decodeAll(readJSON($('[data-sk-pf-i18n]', el)));
    var locale = (el.getAttribute('data-locale') || document.documentElement.lang || 'de').replace('_', '-');
    try { this.fmt = new Intl.NumberFormat(locale, { style: 'currency', currency: 'EUR' }); } catch (e) { this.fmt = new Intl.NumberFormat('de-DE', { style: 'currency', currency: 'EUR' }); }
    try { this.nfmt = new Intl.NumberFormat(locale, { maximumFractionDigits: 0 }); } catch (e) { this.nfmt = new Intl.NumberFormat('de-DE', { maximumFractionDigits: 0 }); }
    this.input = $('[data-sk-pf-plz]', el);
    this.amountEl = $('[data-sk-pf-amount]', el);
    this.lineEl = $('[data-sk-pf-line]', el);
    this.detailEl = $('[data-sk-pf-detail]', el);
    this.meterEl = $('[data-sk-pf-meter]', el);
    this.meterFill = $('[data-sk-pf-meter-fill]', el);
    this.meterText = $('[data-sk-pf-meter-text]', el);
    this.msgEl = $('[data-sk-pf-msg]', el);
    this.mixedEl = $('[data-sk-pf-mixed]', el);
    this.plzRow = $('[data-sk-pf-plzrow]', el);
    this.model = el.getAttribute('data-model') === 'flat' ? 'flat' : 'weight';
    this.neutral = this.lineEl ? this.lineEl.textContent : '';
    this.selection = [];
    this.seq = 0;
    this.timer = 0;
    this.announce = false;
    if (this.input) this.input.value = getPlz();
    if (!this.compact) {
      // Auswahl der Mengen-View (Pop-up liegt im Dialog innerhalb derselben Mengen-View)
      var qm = el.closest('[data-sk-qm]') || $('[data-sk-qm]');
      if (qm) {
        var self0 = this;
        if (qm.__skQmFreight) this.selection = qm.__skQmFreight;
        qm.addEventListener('sk-plant:qm-lines', function (e) {
          self0.selection = (e.detail && e.detail.items) || [];
          self0.schedule(250);
        });
      }
    }
    this.bind();
  }

  Box.prototype.bind = function () {
    var self = this;
    if (!this.input) return;
    this.input.addEventListener('input', function () {
      var v = self.input.value.replace(/\D/g, '').slice(0, 5);
      if (v !== self.input.value) self.input.value = v;
      if (v.length === 5) self.commit(true);
      else if (!v) self.commit(false);
    });
    this.input.addEventListener('keydown', function (e) {
      if (e.key === 'Enter') { e.preventDefault(); self.commit(true); }
    });
    var go = $('[data-sk-pf-go]', this.el);
    if (go) go.addEventListener('click', function () { self.commit(true); });
  };

  /* PLZ übernehmen → alle Kästen (Produktseite, Pop-up, Drawer) rechnen mit derselben PLZ */
  Box.prototype.commit = function (announce) {
    var v = (this.input.value || '').replace(/\D/g, '');
    if (v && v.length !== 5) { this.message(this.i18n.invalid, true); return; }
    setPlz(v);
    var self = this;
    boxes.forEach(function (b) {
      if (b !== self && b.input && b.input.value !== v) b.input.value = v;
      b.schedule(0);
    });
    this.announce = !!announce && !!v;
  };

  Box.prototype.items = function () {
    // Auswahl: nur Zeilen der Klasse (data-cart-ship), Warenkorb: nur Positionen der Klasse
    var sel = this.compact ? [] : this.selection.filter(function (it) { return it.cls === CLS; })
      .map(function (it) { return { sku: it.sku, quantity: it.quantity, grams: it.grams }; });
    return sel.concat(cartItems(CLS));
  };

  Box.prototype.schedule = function (ms) {
    var self = this;
    window.clearTimeout(this.timer);
    this.timer = window.setTimeout(function () { self.run(); }, ms || 0);
  };

  Box.prototype.message = function (text, isError) {
    if (!this.msgEl) return;
    this.msgEl.textContent = text || '';
    this.msgEl.classList.toggle('is-error', !!isError);
    // Erfolg steht schon sichtbar in der Zeile darüber → nur für Screenreader ansagen
    this.msgEl.classList.toggle('is-sr', !!text && !isError);
  };

  Box.prototype.money = function (cents) { return this.fmt.format((cents || 0) / 100); };
  Box.prototype.kg = function (kg) { return this.nfmt.format(Math.max(1, Math.round(kg))); };

  Box.prototype.run = function () {
    var self = this;
    var inCartItems = cartItems(CLS);
    if (this.compact) {
      // Drawer/Warenkorb: nur mit Speditions-Pflanzen; vor dem ersten Warenkorb-Stand nichts zeigen
      var has = inCartItems.length > 0;
      this.el.hidden = !has;
      if (this.mixedEl) this.mixedEl.hidden = !(has && split().otherCents > 0);
      if (!has) return;
    }
    var items = this.items();
    var plz = getPlz();
    var empty = !items.length;
    // Stück je Frachtmodell: kg-Texte zählen nur Pflanzen nach Gewicht, die Paletten-Zeile nur Pauschal-Elemente
    var count = { weight: 0, flat: 0 };
    var inCart = { weight: 0, flat: 0 };
    items.forEach(function (it) { count[isFlatSku(it.sku) ? 'flat' : 'weight'] += it.quantity || 0; });
    inCartItems.forEach(function (it) { inCart[isFlatSku(it.sku) ? 'flat' : 'weight'] += it.quantity || 0; });
    var seq = ++this.seq;
    this.el.classList.add('is-loading');
    var emptyItems = this.model === 'flat' ? FREIGHT_CLASSES[CLS].emptyItemsFlat : FREIGHT_CLASSES[CLS].emptyItems;
    quote(CLS, plz, empty ? emptyItems : items).then(function (res) {
      if (seq !== self.seq) return;
      self.el.classList.remove('is-loading');
      self.show(res || {}, plz, empty, count, inCart);
    }).catch(function () {
      if (seq !== self.seq) return;
      self.el.classList.remove('is-loading');
      self.fail(plz);
    });
  };

  Box.prototype.show = function (res, plz, empty, counts, inCarts) {
    var i = this.i18n;
    var m = res.models || {};
    var flat = m.flat || null;
    var w = m.weight || null;
    // Nur Palettenpauschale (z. B. Fertighecken-Elemente): eigene Darstellung ohne PLZ und kg
    if (flat && !(w && (w.actualKg || 0) > 0)) { this.showFlat(flat, empty, counts.flat, inCarts.flat); return; }
    if (this.plzRow) this.plzRow.hidden = false;
    var count = counts.weight;
    var inCart = inCarts.weight;
    var minKg = res.minBillableKg || 250;
    // Gemischt: Spanne/kg-Texte gelten nur dem Gewichtsteil, die Pauschale steht als eigene Zeile darunter
    var wRange = w && w.range ? w.range : res.range;
    var range = wRange && wRange.fromCents ? wRange : null;
    var rangeText = range ? fill(i.range, { FROM: this.money(range.fromCents), TO: this.money(range.toCents), KG: this.kg(minKg) }) : '';
    var badPlz = !res.ok && !!plz && /postal_code|zone|not_de/.test(res.reason || ''); // z. B. unknown_postal_code

    // Kopfzeile: Betrag nur mit PLZ (ohne PLZ steht die Spanne in der Zeile darunter)
    if (this.amountEl) this.amountEl.textContent = res.ok ? this.money(res.totalCents) : '';
    if (this.lineEl) {
      if (res.ok) this.lineEl.textContent = fill(i.result, { VALUE: plz, PRICE: this.money(res.totalCents) });
      else this.lineEl.textContent = rangeText || fill(i.neutral, { KG: this.kg(minKg) });
    }
    // Menge/Gewicht, davon im Warenkorb, Fracht je Pflanze; Warenkorb: „an der Kasse genauso berechnet"
    var parts = [];
    if (!empty && count > 0) {
      parts.push(count === 1 ? fill(i.for_one, { KG: this.kg(res.actualKg || 0) }) : fill(i.for_other, { N: String(count), KG: this.kg(res.actualKg || 0) }));
      if (!this.compact && inCart > 0) parts.push(fill(i.incl_cart, { N: String(inCart) }));
      if (res.ok && count > 1 && !flat) parts.push(fill(i.per_plant, { PRICE: this.money(Math.round(res.totalCents / count)) }));
    }
    if (flat) {
      parts.push(res.ok && w && w.totalCents != null
        ? fill(i.mixed_detail, { FROM: this.money(w.totalCents), TO: this.money(flat.totalCents) })
        : fill(i.flat_extra, { PRICE: this.money(flat.totalCents) }));
    }
    if (this.compact && res.ok && i.checkout) parts.push(i.checkout);
    if (this.detailEl) {
      this.detailEl.textContent = parts.join(' · ');
      this.detailEl.hidden = !parts.length;
    }
    // Kernbotschaft: bis zum Mindestgewicht bleibt die Fracht gleich
    var under = !empty && res.actualKg > 0 && res.actualKg < minKg;
    if (this.meterEl) {
      this.meterEl.hidden = !under;
      if (under && this.meterFill) this.meterFill.style.width = Math.max(3, Math.min(100, (res.actualKg / minKg) * 100)).toFixed(1) + '%';
    }
    if (this.meterText) {
      this.meterText.hidden = !under;
      if (under) this.meterText.textContent = fill(i.meter, { KG: this.kg(minKg - res.actualKg), MIN: this.kg(minKg) });
    }
    if (badPlz) this.message(i.invalid, true);
    else if (this.announce && res.ok) this.message(fill(i.result, { VALUE: plz, PRICE: this.money(res.totalCents) }), false);
    else this.message('', false);
    this.announce = false;
  };

  /* Nur Palettenpauschale: Betrag steht ohne PLZ fest (deutschlandweit gleich); Balken = Füllstand der letzten Palette */
  Box.prototype.showFlat = function (flat, empty, count, inCart) {
    var i = this.i18n;
    if (this.plzRow) this.plzRow.hidden = true;
    if (this.amountEl) this.amountEl.textContent = this.money(flat.totalCents);
    if (this.lineEl) this.lineEl.textContent = fill(i.flat_line, { PRICE: this.money(flat.perPalletCents) });
    var parts = [];
    if (!empty && count > 0) {
      parts.push(fill(i.flat_for, { N: String(count), P: String(flat.pallets) }));
      if (!this.compact && inCart > 0) parts.push(fill(i.incl_cart, { N: String(inCart) }));
    }
    if (this.compact && i.checkout) parts.push(i.checkout);
    if (this.detailEl) {
      this.detailEl.textContent = parts.join(' · ');
      this.detailEl.hidden = !parts.length;
    }
    var share = flat.palletShare || 0;
    var room = !empty && share > 0 && share < flat.pallets - 1e-9;
    if (this.meterEl) {
      this.meterEl.hidden = !room;
      if (room && this.meterFill) this.meterFill.style.width = Math.max(3, Math.min(100, (1 - (flat.pallets - share)) * 100)).toFixed(1) + '%';
    }
    if (this.meterText) {
      this.meterText.hidden = !room;
      if (room) this.meterText.textContent = i.flat_meter || '';
    }
    this.message('', false);
    this.announce = false;
  };

  Box.prototype.fail = function (plz) {
    if (this.amountEl) this.amountEl.textContent = '';
    if (this.lineEl) this.lineEl.textContent = this.neutral;
    if (this.detailEl) this.detailEl.hidden = true;
    if (this.meterEl) this.meterEl.hidden = true;
    if (this.meterText) this.meterText.hidden = true;
    this.message(plz ? this.i18n.error : '', !!plz);
    this.announce = false;
  };

  /* ---------- Pop-up „zzgl. Versandkosten" ---------- */
  function openModal(trigger) {
    if (!modal || typeof modal.showModal !== 'function') return;
    lastTrigger = trigger || document.activeElement;
    var box = $('[data-sk-plant-freight]', modal);
    if (box && box.__skPf) box.__skPf.schedule(0);
    document.documentElement.classList.add('sk-pf-modal-open');
    modal.showModal();
    var input = $('[data-sk-pf-plz]', modal);
    // Mit gemerkter PLZ auf „Schließen", sonst direkt ins PLZ-Feld
    var focusEl = input && !input.value ? input : $('[data-sk-pf-close]', modal);
    if (focusEl) { try { focusEl.focus({ preventScroll: true }); } catch (e) { focusEl.focus(); } }
  }
  function initModal() {
    modal = $('[data-sk-pf-modal]');
    var triggers = $$('[data-sk-pf-open]');
    if (!modal || typeof modal.showModal !== 'function') {
      // Kein Pop-up auf der Seite (z. B. Mengen-View aus) → wieder normaler Text
      triggers.forEach(function (t) { t.replaceWith(document.createTextNode(t.textContent)); });
      return;
    }
    if (modal.parentNode !== document.body) document.body.appendChild(modal); // nicht im Warenkorb-Formular verschachteln
    triggers.forEach(function (t) { t.setAttribute('aria-controls', modal.id); });
    document.addEventListener('click', function (e) {
      var t = e.target.closest && e.target.closest('[data-sk-pf-open]');
      if (t) { e.preventDefault(); openModal(t); }
    });
    $$('[data-sk-pf-close]', modal).forEach(function (b) { b.addEventListener('click', function () { modal.close(); }); });
    // Klick auf den abgedunkelten Hintergrund schließt
    modal.addEventListener('click', function (e) { if (e.target === modal) modal.close(); });
    modal.addEventListener('close', function () {
      document.documentElement.classList.remove('sk-pf-modal-open');
      if (lastTrigger && document.documentElement.contains(lastTrigger)) { try { lastTrigger.focus(); } catch (e) { /* weg */ } }
    });
    // Esc selbst behandeln: globale keydown-Handler anderer Skripte (preventDefault) verhindern sonst das native „cancel"
    // Fokus-Falle (zusätzlich zum inerten Hintergrund des nativen Dialogs; Browser-UI bleibt erreichbar)
    modal.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') { e.preventDefault(); e.stopPropagation(); modal.close(); return; }
      if (e.key !== 'Tab') return;
      var f = $$('button, input, a[href], [tabindex]:not([tabindex="-1"])', modal).filter(function (x) { return !x.disabled && x.offsetParent !== null; });
      if (!f.length) return;
      var first = f[0];
      var last = f[f.length - 1];
      if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
    });
  }

  /* ---------- Start ---------- */
  function mount() {
    var found = false;
    $$('[data-sk-plant-freight]').forEach(function (el) {
      if (el.__skPf) return;
      el.__skPf = new Box(el);
      boxes.push(el.__skPf);
      found = true;
    });
    // Nicht mehr im Dokument (Empire hat /cart neu gerendert) → loslassen
    boxes = boxes.filter(function (b) { return document.documentElement.contains(b.el); });
    return found;
  }

  function init() {
    learnClasses();
    initModal();
    if (!mount()) return;
    loadCart().then(function () {
      // Ohne Warenkorb-Antwort trotzdem rechnen (Produktseite: Auswahl/Spanne)
      if (!cart) boxes.forEach(function (b) { b.schedule(0); });
    });
    window.addEventListener('cartcount:update', function (e) {
      learnClasses();
      if (e.detail && e.detail.items) setCart(e.detail);
      else loadCart();
    });
    window.addEventListener('sk:cart-changed', function (e) {
      if (e.detail && e.detail.cart) setCart(e.detail.cart);
    });
    if (window.MutationObserver) {
      var pending = false;
      new MutationObserver(function () {
        if (pending) return;
        pending = true;
        window.requestAnimationFrame(function () {
          pending = false;
          if (mount()) loadCart();
        });
      }).observe(document.body, { childList: true, subtree: true });
    }
  }

  window.skPlantFreight = { setCart: setCart, split: split, classes: FREIGHT_CLASSES };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
